import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { defaultFee } from "../../rbac-consts";
import { default as AdminDefaultFeeContainer } from "./admin/DefaultFeeContainer";

const DefaultFeeWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={defaultFee.ADMIN}
      yes={() => (
        <AdminDefaultFeeContainer />
      )}
    />
  );
};

export default DefaultFeeWrapper;